<template>
  <v-form v-model="valid" ref="form" lazy-validation>
    <v-layout row wrap v-if="atualizar">
      <v-flex xs12>
        <h2 class="mb-1">Seleciones as habilidades a serem Auto-avaliadas:</h2>
      </v-flex>
      <show-criterio
      style="width: 100%"
      :criterios="habilidades"
      :solicitacao="solicitacao"
      :titulo="false"
      :botaosaved="false"
      :btnedit="false"
      @saved="atualHabilidade">
      </show-criterio>
      <v-flex xs12>
        <v-spacer></v-spacer>
        <v-layout align-center justify-end row fill-height>
          <div class="mt-5">
            <v-btn color="primary"  @click.native="$emit('prev')" >voltar</v-btn>
            <v-btn color="primary"  @click.native="proximo" >Continuar</v-btn>
          </div>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-dialog id="dialog" v-model="dialog" max-width="100%" persistent>
      <v-card v-for="(solicitacao, index) in selectHabilidade" :key="solicitacao.id" class="ma-2">
        <v-card-title> 
          <h3>Habilidade :</h3>{{solicitacao.name}}
        </v-card-title>
        <v-card-text>
          <v-text-field 
            label="Titulo da solicitação" 
            hint="Nome da habilidade que será mostrada para o aluno"
            v-model="autoAvalname[index]"></v-text-field>
          <v-text-field 
            label="Descrição da solicitação" 
            hint="Descrição para o aluno de como realizar a evidência"
            v-model="autoAvaldescription[index]"></v-text-field>
          </v-card-text>
        <v-card-actions>
        </v-card-actions>
      </v-card>
      <v-btn @click="fechar()">continuar</v-btn>
    </v-dialog>
  </v-form>

</template>

<script>
// import api from '@/api'
import ShowCriterio from '@/components/reusable/showCriterio.vue'
export default {
  components: {
    ShowCriterio
  },
  props: [
    'step2Data',
    'i'
  ],
  data () {
    return {
      result: {},
      tabela: false,
      habilidades: [],
      arquivos: false,
      autoAval: [],
      autoAvalname: [],
      autoAvaldescription: [],
      dialog: false,
      solicitacao: true,
      options: {},
      selectHabilidade: [],
      criterios_selecionados: [],
      valid: true,
      atualizar: true,
      titulo: true,
      menu2: false
    }
  },
  mounted () {
    this.$watch('i', function () {
      this.pickHabilidade(this.step2Data)
    })
  },
  computed: {
  },
  methods: {
    proximo () {
      if (this.selectHabilidade.length > 0) {
        this.dialog = true
      } else {
        this.$emit('next')
      }
    },
    pickHabilidade (dado) {
      this.habilidades = []
      this.atualizar = false
      for (let index = 0; index < dado.length; index++) {
        this.habilidades = this.habilidades.concat(dado[index].habilidades_pks)
      }
      this.atualizar = true
      // console.log('aqui', this.habilidades)
    },
    fechar () {
      for (let index = 0; index < this.autoAvalname.length; index++) {
        this.autoAval[index] = {
          'title': this.autoAvalname[index],
          'description': this.autoAvaldescription[index],
          'habilidades_pks': [this.selectHabilidade[index].id],
          'evidencia_foco': true
        }
      }
      this.dialog = false
      this.$emit('avaliacao', this.autoAval)
      this.$emit('next')
    },
    atualHabilidade (dado) {
      this.selectHabilidade = dado
      // console.log('selecthabil', dado)
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Padroes/CadastroSteps/Step3.vue